// Tracks the on-screen keyboard's height and publishes it as a CSS variable
// `--keyboard-inset-bottom` on the document root. Fixed-position UI that would
// otherwise sit beneath the keyboard (e.g. the wizard's speichern button) can
// add this inset to its `bottom` via `max(...)` and ride up with the keyboard.
//
// iOS WKWebView and desktop browsers: VisualViewport reflects the visible area
// (layout minus keyboard), so `innerHeight - vv.height` is the keyboard inset.
//
// Android WebView: VisualViewport doesn't work here because the layout viewport
// resizes when the IME appears (innerHeight shrinks with vv.height, delta is 0).
// Instead MainActivity.java reads `WindowInsetsCompat.Type.ime()` natively and
// writes --keyboard-inset-bottom from the activity-side WindowInsets listener.
// We skip the JS installer on Android so it doesn't overwrite the native value
// with 0 on every resize.

import { Capacitor } from '@capacitor/core'

let installed = false

export function installKeyboardInset(): void {
  if (installed) return
  installed = true

  if (Capacitor.getPlatform() === 'android') return

  const vv = window.visualViewport
  if (!vv) return

  const update = (): void => {
    // `offsetTop` is non-zero under pinch-zoom; subtracting it ensures we
    // only report the inset that's actually keyboard, not scroll/zoom.
    const inset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop)
    document.documentElement.style.setProperty('--keyboard-inset-bottom', `${inset}px`)
  }

  vv.addEventListener('resize', update)
  vv.addEventListener('scroll', update)
  update()
}
